<template>
  <div
    ref="wrap"
    class="infinite-scroll-wrap"
  >
    <slot
      :items="items"
      :modelIds="modelIds"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
export default {
  name: "WsInfiniteScrollWrap002",
  props: {
    modelName: {
      type: String,
      default: "",
    },
    modelParent: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    parentLayers: {
      type: Array,
      default() {
        return [];
      },
    },
    parentModels: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    C_params: {},
    items: [],
    isLoading: false,
    page: 1,
    lastPage: 1,
    C_parentLayers: {},
    C_parentModels: {},
    isFirst: false,
    modelIds: {},
    orderRules: {},
  }),
  watch: {
    params: {
      deep: true,
      handler() {
        this.$_resetFetchData();
      },
    },
    parentModels: {
      deep: true,
      handler() {
        if (
          this.parentLayers &&
          this.parentModels[this.parentLayers[0].name].length === 0
        )
          return;
        this.$_resetFetchData();
      },
    },
  },
  mounted() {
    this.$_resetFetchData();
  },
  created() {
    window.addEventListener("scroll", this.$_scrollHandle);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.$_scrollHandle);
  },
  methods: {
    $_scrollHandle() {
      if (!this.$refs.wrap) return;
      let element = this.$refs.wrap.getBoundingClientRect();
      if (
        element.height + element.y - 100 <= window.innerHeight &&
        !this.isLoading
      ) {
        if (this.parentLayers) {
          this.$_scrollFetch(
            this.C_parentLayers,
            this.parentModels,
            this.parentLayers
          );
        } else {
          this.$_loadNextPage();
        }
      }
    },
    $_getModelIds(C_modelIndexs, C_modelObject, parentNameLayers) {
      //得到依序送出得條件
      const _modelIds = {};
      if (parentNameLayers.length === 0) return;
      parentNameLayers.forEach((parentNameLayer) => {
        const _modelName = parentNameLayer.name;
        const _tarModelId = this.$_getTargetModelId(
          C_modelIndexs,
          C_modelObject,
          parentNameLayers,
          _modelName
        );
        _modelIds[_modelName] = _tarModelId;
      });
      return _modelIds;
    },
    $_getTargetModelId(
      C_modelIndexs,
      C_modelObject,
      parentNameLayers,
      modelName
    ) {
      const targetLayerIndex = parentNameLayers.findIndex((e) => {
        return e.name == modelName;
      });
      let targerObject = C_modelObject;
      for (let index = 0; index <= targetLayerIndex; index++) {
        const _modelName = parentNameLayers[index].name;
        const _targetIndex = C_modelIndexs[_modelName];
        const _items = targerObject[_modelName];
        if (!_targetIndex && _targetIndex !== 0) return;
        if (_items.length === 0) return;
        targerObject = _items[_targetIndex];
      }
      if (!targerObject) {
        return;
      }
      return targerObject.id;
    },
    $_setParams() {
      this.C_params = { ...this.params };
    },
    $_setParentModels() {
      for (let prop in this.parentModels) {
        this.C_parentModels[prop] = this.parentModels[prop];
      }
    },
    $_setParentLayers() {
      this.parentLayers.forEach((layer) => {
        this.$set(this.C_parentLayers, layer.name, 0);
        this.C_parentLayers[`pre_${layer.name}`] = -1;
      });
    },
    $_resetFetchData() {
      this.items = [];
      this.$_setParams();
      this.$_setParentLayers();
      this.$_setParentModels();
      this.$_fetchData();
    },
    async $_fetchData() {
      if (this.isLoading) return;
      if (!this.modelName || (!this.modelName && !this.modelParent)) return;
      try {
        this.isLoading = true;
        this.orderRules = {};
        if (this.parentLayers) {
          if (
            !this.C_parentLayers ||
            !this.parentModels ||
            !this.parentLayers.length
          ) {
            return;
          }
          const modelLayers = await this.$_getModelIds(
            this.C_parentLayers,
            this.parentModels,
            this.parentLayers
          );
          this.modelIds = modelLayers; //依序送條件（subclasses...)
        }
        const _params = {
          page: this.page,
          ...this.C_params,
          ...this.orderRules,
        };
        const res = await this.$axios.get(
          `/${this.modelParent}${this.modelName}`,
          {
            params: _params,
          }
        );
        this.items = [...res.data.data];
        this.lastPage = res.data.meta.last_page;
        this.isLoading = false;
        if (this.parentLayers && res.data.data.length < 15) {
          this.$_scrollFetch(
            this.C_parentLayers,
            this.parentModels,
            this.parentLayers
          );
        }
      } catch (err) {
        this.isLoading = false;
      }
    },
    $_loadNextPage() {
      if (this.page < this.lastPage) {
        this.page += 1;
        this.$_fetchData();
      }
    },
    $_scrollFetch(C_modelIndexs, C_modelObject, parentNameLayers) {
      if (!parentNameLayers.length) return;
      if (this.page < this.lastPage) {
        this.page += 1;
        this.$_fetchData();
        return;
      }
      const allIndex = parentNameLayers.length;
      for (let index = allIndex - 1; index >= 0; index--) {
        const targetLayerIndex = index;
        let targerObject = C_modelObject;
        let _modelName = "";
        let _targetIndex = 0;
        let _items = null;
        for (let index = 0; index <= targetLayerIndex; index++) {
          _modelName = parentNameLayers[index].name;
          _targetIndex = C_modelIndexs[_modelName];
          _items = targerObject[_modelName];
          if (!_items) return;
          targerObject = _items[_targetIndex];
        }
        if (C_modelIndexs[_modelName] + 1 < _items.length) {
          this.C_parentLayers[_modelName] += 1;
          this.page = 1;
          this.parentLayers.forEach((layer, layerIndex) => {
            if (layerIndex > targetLayerIndex) {
              this.C_parentLayers[layer.name] = 0;
            }
          });
          this.$_fetchData();
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss">
</style>